import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../_metronic/_partials/controls";
import BootstrapTable from "react-bootstrap-table-next";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from "../../_metronic/_helpers";
import { useSubheader } from "../../_metronic/layout";
import { Link, useHistory } from "react-router-dom";
import { baseURLV1, baseURL, imageURL } from "../service/API.js";
import moment from "moment";
import Swal from "sweetalert2";
import axios from "axios";
import paginationFactory from "react-bootstrap-table2-paginator";
import Pagination2 from "@material-ui/lab/Pagination";
import { useSelector } from "react-redux";
import { Modal, Container, Row, Col, Form, Button, Nav } from "react-bootstrap";

export const ContractUsManagement = () => {
  const suhbeader = useSubheader();
  const allData = [];
  const [templateData, setTemplateData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [show, setShow] = useState(false);
  const [currentRow, setCurrentRow] = useState([])
  const [message, setMassage] = useState();
  const [totalSize, setTotalSize] = useState(100);
  const [is_loading, setIs_Loading] = useState(false);
  const [listError, setlistError] = useState(false);
  const [isSend, setIsSend] = useState('0');
  suhbeader.setTitle("Contact Us Management");
  const { user } = useSelector((state) => state.auth);
  const [listMasterModel, setListMasterModel] = useState([]);
  const [columnRecord, setColumnRecord] = useState([])

  const history = useHistory();
  useEffect(() => {
    getListMasterModel(page, limit);
  }, []);
  const handleClose = () => setShow(false);

  const getListMasterModel = async (page, limit, status = isSend) => {
    setIs_Loading(true);
    const apiUrls = `${baseURLV1}/contractUS?page=${page}&limit=${limit}&status=${status}`; // รอแก้
    await axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${user.data.access_token}`,
      },
    })
      .then((res) => {
        res.data.data.map(item => {
          item.date_record = ISOString(item.date_record)
          if (item.feedback_record) item.feedback_record = ISOString(item.feedback_record)
          item.realUser.firstname = `${item.realUser.firstname} ${item.realUser.lastname}`
        })
        setListMasterModel(res.data.data);
        setIs_Loading(false);
        setlistError(false);
        var totalpage = Math.ceil(res.data.total / res.data.limit);
        setTotalPage(totalpage);
        setTotalSize(res.data.total);
        setLimit(res.data.limit);
        setTemplateData(allData);
      })
      .catch((err) => {
        if (err.response) {
          setIs_Loading(false);
          setlistError(true);
        }
      });
  };

  const ISOString = (data) => {
    console.log(`${data.toString().substring(0, 10)} ${data.toString().substring(11, 16)}`)
    return `${data.toString().substring(0, 10)} ${data.toString().substring(11, 16)}`
    // console.log(Date(data).toISOString())
  };




  const columns = [

    {
      dataField: "topic.name",
      text: "Topic Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },

    {
      dataField: "details",
      text: "Desription",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },

    {
      text: "Image",
      dataField: "image_path",
      formatter: (img, row, rowIndex) => {
        return (
          <div>
            {/*<a
              onClick={() => {
                setOpenImage(true);
                setImgSelect(row.image);
              }}
            >*/}
            <img
              style={{
                width: "100px",
                height: "100px",
              }}
              src={`${imageURL}/${row.image_path}`}
            />
            {/* </a>*/}
          </div>
        );
      },
    },
    {
      dataField: "date_record",
      text: "Date Record",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },

    {
      dataField: "realUser.firstname",
      text: "Username",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },

    {
      text: "Feedback Record",
      dataField: "feedback_record",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Feedback Log",
      dataField: "id",
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <button
              type="button"
              className="btn btn-primary mr-2"
              onClick={() => editItem({ id, row, rowIndex })}
            >
              View Feedback
            </button>
          </div>
        );
      },
    },
    {
      text: "Action",
      dataField: "id",
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <button
              type="button"
              className="btn btn-primary mr-2"
              onClick={() => {
                console.log(row)
                setShow(true)
                setCurrentRow(row)
                setMassage(`Dear ${row.realUser.name}\n`)
              }}
            >
              Feedback
            </button>
          </div>
        );
      },
    },
  ]

  const column2 = [

    {
      dataField: "topic.name",
      text: "Topic Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },

    {
      dataField: "details",
      text: "Desription",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },

    {
      text: "Image",
      dataField: "image_path",
      formatter: (img, row, rowIndex) => {
        return (
          <div>
            {/*<a
              onClick={() => {
                setOpenImage(true);
                setImgSelect(row.image);
              }}
            >*/}
            <img
              style={{
                width: "100px",
                height: "100px",
              }}
              src={`${imageURL}/${row.image_path}`}
            />
            {/* </a>*/}
          </div>
        );
      },
    },
    {
      dataField: "date_record",
      text: "Date Record",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },

    {
      dataField: "realUser.name",
      text: "Username",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Action",
      dataField: "id",
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <button
              type="button"
              className="btn btn-primary mr-2"
              onClick={() => {
                console.log(row)
                setShow(true)
                setCurrentRow(row)
                setMassage(`Dear ${row.realUser.name}\n`)
              }}
            >
              Feedback
            </button>
          </div>
        );
      },
    },
  ]

  const editItem = (data) => {
    history.push("/FeedbackLog", data);
  };

  const sendMail = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "are you sure to send email",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, send it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        let token = localStorage.getItem("Token");
        let apiUrls = `${baseURLV1}/mail`;
        //const text = message.split('\n')
        /*let send = ''
        for (let i = 0;i<text.length;i++) {
          send = send+`<p>${text[i]}</p>`
        }*/
        console.log(message)

        var events = {
          topicName: currentRow.details,
          id: String(currentRow.id),
          text: message,
          user: String(currentRow.user_id)
        };
        const resultAll = axios({
          method: "post",
          url: apiUrls,
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
          data: events,
        }).then(res => {
          setShow(false)
          getListMasterModel(page, limit)
          Swal.fire("Email has been send!", "", "success");
        }).catch((err) => {
          Swal.fire(
            "Error!",
            "Can not send your Email.",
            "error"
          );
        });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled send email", "", "error");

      }
    })

  };
  const [search, setSearch] = useState();
  const handleSearch = () => {
    setPage(1);
    getListMasterModel(1, limit, search);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    getListMasterModel(value, limit);
  };

  const handlePageSizeChange = (event) => {
    setLimit(event.target.value);
    getListMasterModel(1, event.target.value);
  };

  return (
    <>
      <Card>
        <CardHeader title="Contact Us Management">
          <CardHeaderToolbar>
            {/*<Link to="/CreateContractusManagement">
            <button type="button" className="btn btn-primary">
              + Create
            </button>
          </Link>*/}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>


          <Nav variant="tabs" defaultActiveKey="link-0">
            <Nav.Item onClick={() => {
              getListMasterModel(1, limit, '0')
              setIsSend('0')
            }}>
              <Nav.Link eventKey="link-0">wait for Feedback</Nav.Link>
            </Nav.Item>
            <Nav.Item onClick={() => {
              getListMasterModel(1, limit, '1')
              setIsSend('1')

            }}>
              <Nav.Link eventKey="link-1">Feedback</Nav.Link>
            </Nav.Item>
          </Nav>

          {Boolean(Number(isSend)) && <BootstrapTable
            keyField="id"
            data={listMasterModel}
            columns={columns}
            wrapperClasses="table-responsive"
            bordered={false}
            classes="table table-head-custom table-vertical-center overflow-hidden"
            bootstrap4
          />
          }
          {
            !Boolean(Number(isSend)) && <BootstrapTable
              keyField="id"
              data={listMasterModel}
              columns={column2}
              wrapperClasses="table-responsive"
              bordered={false}
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
            />
          }
          <div className=" col-lg-12">
            <div className="row">
              <div className="col-lg-6">
                <div className="mt-3">
                  {"Items per Page: "}
                  <select onChange={handlePageSizeChange} value={limit}>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                </div>
              </div>
              <div className="col-lg-6">
                <Pagination2
                  className="mt-3 "
                  count={totalPage}
                  page={page}
                  siblingCount={1}
                  boundaryCount={1}
                  variant="outlined"
                  shape="rounded"
                  onChange={handlePageChange}
                />
              </div>
            </div>
          </div>
          <Modal
            className="modal-center"
            backdrop={"static"}
            show={show}
            onHide={handleClose}
          >
            <Modal.Body>
              <h3 style={{ textAlign: "center", fontWeight: "bold" }}>
                Feed Back
              </h3>
              <p style={{ textAlign: "center" }}>
                message
              </p>
              <div style={{ width: '300px' }}>
                <textarea
                  style={{
                    resize: 'none',
                    height: "150px",
                    width: "450px",
                    backgroundColor: "#F4F6F9",
                    borderRadius: "5px",
                    borderWidth: "0",
                  }}
                  name="commentTextArea"
                  type="text"
                  id="CommentsOrAdditionalInformation"
                  value={message}
                  onChange={(e) => {
                    setMassage(e.target.value);
                  }}
                >
                </textarea>

              </div>
            </Modal.Body>
            <Modal.Footer>
              <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => { sendMail() }}>Send</button>
              <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => { setShow(false) }}>Cancel</button>
            </Modal.Footer>
          </Modal>
        </CardBody>
      </Card>
    </>
  );
};
